import { render, staticRenderFns } from "./spareProcurement.vue?vue&type=template&id=001d86ac&scoped=true"
import script from "./spareProcurement.vue?vue&type=script&lang=js"
export * from "./spareProcurement.vue?vue&type=script&lang=js"
import style0 from "./spareProcurement.vue?vue&type=style&index=0&id=001d86ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001d86ac",
  null
  
)

export default component.exports